import { createSlice } from "@reduxjs/toolkit";

export const AlertSlice = createSlice({
  name: 'alert',
  initialState: {
    alerts: [],
  },
  reducers: {
    addAlert: (state, action) => {
      if(action.payload.name !== "CanceledError") {
        let id = Math.floor(Math.random() * 1000);
        if (action.payload?.response?.data) {
          const { data } = action.payload.response;
          if(data.identifier) id = data.identifier;
        }
        state.alerts.push({
          id,
          message:  action.payload.message,
          name:  action.payload.name,
          code:  action.payload.code,
        });
      }
    },
    closeAlert: (state, action) => {
      state.alerts = state.alerts.filter((alert) => {
       return (alert.id !== action.payload)
      });
    },
  },
});

// Action creators are generated for each case reducer function
export const { addAlert, closeAlert } = AlertSlice.actions

export default AlertSlice.reducer
